import React from 'react';
import { useLanguage } from '../context/LanguageContext';
export function Footer() {
  const {
    t
  } = useLanguage();
  return <footer className="bg-slate-950 text-slate-400 py-12 border-t border-slate-900" data-id="element-59">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-60">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12" data-id="element-61">
          <div className="col-span-1 lg:col-span-2" data-id="element-62">
            <h3 className="text-white text-xl font-bold mb-4" data-id="element-63">
              Lehigh Valley Weight Loss
            </h3>
            <p className="mb-4 text-slate-400" data-id="element-64">Maneesh Ailawadi, MD, FSSO</p>
            <address className="not-italic mb-4" data-id="element-65">
              2200 Hamilton St #111
              <br data-id="element-66" />
              Allentown, PA 18104
            </address>
            <a href="tel:4849341070" className="text-teal-500 hover:text-teal-400 font-medium" data-id="element-67">
              484-934-1070
            </a>
          </div>

          <div className="col-span-1 lg:col-span-2 text-sm space-y-4" data-id="element-68">
            <div className="p-4 bg-slate-900/50 rounded-lg border border-slate-900" data-id="element-69">
              <p className="mb-2 font-semibold text-slate-300" data-id="element-70">
                {t('Medical Disclaimer', 'Aviso médico')}
              </p>
              <p data-id="element-71">
                {t('This page is for informational purposes only and does not provide medical advice. Consult a qualified healthcare professional for diagnosis and treatment.', 'Esta página es solo informativa y no sustituye consejo médico. Consulte con un profesional de salud calificado.')}
              </p>
            </div>

            <div className="p-4 bg-slate-900/50 rounded-lg border border-slate-900" data-id="element-72">
              <p className="mb-2 font-semibold text-slate-300" data-id="element-73">
                {t('Privacy', 'Privacidad')}
              </p>
              <p data-id="element-74">
                {t('Do not submit highly sensitive medical information through this form.', 'No envíe información médica altamente sensible por este formulario.')}
              </p>
            </div>
          </div>
        </div>

        <div className="border-t border-slate-900 pt-8 flex flex-col md:flex-row justify-between items-center text-sm" data-id="element-75">
          <p data-id="element-76">
            &copy; {new Date().getFullYear()} Lehigh Valley Weight Loss. All
            rights reserved.
          </p>
          <div className="mt-4 md:mt-0 flex space-x-6" data-id="element-77">
            {/* Placeholder links */}
            <span className="hover:text-white cursor-pointer transition-colors" data-id="element-78">
              Privacy Policy
            </span>
            <span className="hover:text-white cursor-pointer transition-colors" data-id="element-79">
              Terms of Service
            </span>
          </div>
        </div>
      </div>
    </footer>;
}